import React, { FunctionComponent } from 'react';
import { Column, Row } from '@/components';
import useScreenSize from '@/hooks/useScreenSize';
import { TypeImageInput } from '../ImageManagerV2';
import { InputImage } from '../Input/InputImage';

type ImagesManagerProps = {
  coverImage?: string;
  handleCoverImage: (image: string) => void;
  error?: string;
  preview?: JSX.Element;
  isInfoMode?: boolean;
};

export const ImagesManager: FunctionComponent<ImagesManagerProps> = ({
  coverImage,
  handleCoverImage,
  preview
}) => {
  const { isMd } = useScreenSize();

  return (
    <div className="mb-8 mt-8">
      <div className="flex">
        <label className="text-lg font-medium">Imagen de portada</label>
      </div>
      <Row gap={20} justify="flex-start" align="flex-start">
        <Column className="relative">
          <label className="font-normal text-xs mb-8 ml-2 text-[#858585]">Máx 10MB (jpeg, png)</label>
          <InputImage
            type={TypeImageInput.SERVICE}
            width={isMd ? '298px' : '248px'}
            height={isMd ? '298px' : '248px'}
            img={coverImage}
            handleImg={handleCoverImage}
          />
        </Column>
        {preview && (
          <Column className="hidden md:flex">
            <label className="font-normal text-xs mb-8 ml-3 text-[#858585]">Vista previa</label>
            {preview}
          </Column>
        )}
      </Row>
    </div>
  );
};
